import axios from 'axios';
import { difference } from 'lodash';
import {
  loadPagesByBookId,
  removeImageFromFlyLeaf,
  setIsActive,
  setLayoutToActivePage,
  addDroppedImageToPage,
  deletePages,
  autoFill } from './../actions/entities/pages';

import {
  loadLayoutsByBookId,
  removeDefaultLayout,
  addLayout } from './../actions/entities/layouts';
import { loadPlaceholdersByBookId } from './../actions/entities/placeholders';
import { loadBackgroundPlaceholderByBookId } from './../actions/entities/backgroundPlaceholders';
import {
  loadImagesByBookId,
  deleteImages,
  loadImages } from './../actions/entities/images';
import {
  autofillFinished,
  convertFinished } from './../actions/entities/io';
import { loadCoverDetailsByBookId } from './../actions/entities/cover';
import { loadBookBackgroundType, loadEditorBookProperties } from './../actions/ui/bookProperties';
import { loadAutoFill } from './../actions/ui/setAutoFill';

// Pro or consuer cover (reconfigured book)
import loadProCoverTemplates from '../../config/templates/covers/pro';
import loadConsumerCoverTemplates from '../../config/templates/covers/consumer';

import {
  loadTextsByBookId,
  deleteText,
} from './../actions/entities/texts';


import {
  addPageToViewed,
  loadPageToViewed,
  resetPageToViewed } from './../actions/ui/addPageToViewed';

import {
  loadBookSizesByBookId,
  loadBookCoverByBookId,
  updateCoverMarginSize,
  loadPlaceholderBorderSize,
  loadBookContext,
  loadBabyBookStatus,
} from './../actions/bookproperties';
import {
  getBookId,
  getDomain,
} from './../helpers/getParams';
import {
  loadDefaultImages,
  configExist,
  getSelectedCover,
  showAlertModal,
  getCoverOrientation,
  getEditorImages } from './../helpers';
import { imageChange } from '../actions/ui/imageChange';
import { isSavedBook } from '../actions/ui/isSavedBook';

const referer = getDomain();
const getStateUrl = configExist('getStateUrl', referer);
const coverterUrl = configExist('converterUrl', referer);
const url = `${getStateUrl}/${getBookId()}/editorjson`;

function loadBookPartials(json, dispatch, coverSize, isConverted = false) {
  const { entities, bookProperties, editorUI } = json;

  const placeholderBorderSize = bookProperties.placeholderBorderSize ? bookProperties.placeholderBorderSize : 0;

  // Book properties, pages, layouts and placeholders
  dispatch(loadBookSizesByBookId(bookProperties.bookSizes));
  dispatch(loadBookCoverByBookId(bookProperties.cover));
  dispatch(loadBookContext(bookProperties.context));

  // Load baby book status if exist
  if (bookProperties.isBabyBook !== undefined) {
    dispatch(loadBabyBookStatus(bookProperties.isBabyBook));
  }

  dispatch(loadPlaceholderBorderSize(placeholderBorderSize));
  if (!isConverted) {
    dispatch(loadPagesByBookId(entities.pages));
  }
  dispatch(loadLayoutsByBookId(entities.layouts));
  dispatch(loadPlaceholdersByBookId(entities.placeholders));

  // load BackgroundPlaceholder if exist
  if (entities.backgroundPlaceholders !== undefined) {
    dispatch(loadBackgroundPlaceholderByBookId(entities.backgroundPlaceholders));
  }
  // load texts
  if (entities.texts) {
    dispatch(loadTextsByBookId(entities.texts));
  }

  // editorUI
  dispatch(loadBookBackgroundType(editorUI.bookProperties));
  dispatch(loadPageToViewed(editorUI.addPageToViewed));
  dispatch(loadAutoFill(editorUI.setAutoFill));
  dispatch(loadEditorBookProperties(editorUI.bookProperties));

  // Load images
  dispatch(loadImagesByBookId(entities.images));

  // Cover Details
  dispatch(loadCoverDetailsByBookId(entities.cover));

  if (!isConverted) {
    dispatch(autofillFinished(true));
  }
  dispatch(imageChange(false));

  // Temp for saved book
  const newPhotoCoverBook = Object.values(entities.layouts.byId).find(element => element.photoCoverLayoutVersion);
  if (newPhotoCoverBook !== undefined) {
    const photoCoverMargin = {
      left: 20,
      right: 20,
      top: 10,
      bottom: 10,
    };
    dispatch(updateCoverMarginSize(photoCoverMargin));
  }
  /*
    dispatch(updateCoverMarginSize(coverSize));
  */
  dispatch(isSavedBook(true));
}

// Remove picture / pictures from cover
function removeCoverPicture(dispatch, coverPage) {
  const { placeholders, id } = coverPage;
  Object.values(placeholders).forEach((element) => {
    dispatch(removeImageFromFlyLeaf(id, element.placeholderId));
  });
}

// Set cover to activePage
function setCoverToActive(dispatch, coverPage) {
  const { id, isActive } = coverPage;
  if (!isActive) {
    dispatch(setIsActive(id));
  }
}

// Remove cover text (reconfigured book)
function removeTextsFromCover(dispatch, coverPage) {
  if ('texts' in coverPage) {
    coverPage.texts.forEach(text => dispatch(deleteText(text)));
  }
}

// Remove cover layout after book convert
function removeOldCoverLayout(dispatch, json) {
  const { byId } = json.entities.layouts;
  const { label } = json.bookProperties.cover;
  const { width } = json.bookProperties.cover.coverSizes;
  const oldCoverLayout = Object.values(byId).filter((element) => {
    const otherLayout = (element.label !== label || element.width !== width) && element.label !== undefined;
    return otherLayout;
  });
  Object.values(oldCoverLayout).forEach((element) => {
    dispatch(removeDefaultLayout(element.id));
  });
}

// Add new cover layout after book covert
function addNewCoverLayout(dispatch, json) {
    const { byId } = json.entities.layouts;
    const { pageWidth, pageHeight } = json.bookProperties.dimensions;
    const { type, label } = json.bookProperties.cover;
    const { context } = json.bookProperties;
    const getCoverlayouts = Object.values(byId).filter(element => element.isCover);
    const format = getCoverOrientation(pageWidth, pageHeight);
  
    const selectedBackgroundType = json.editorUI.bookProperties.backgroundType
  
    const getLayoutsByBGAndContext = 
     (context === 'pro' && selectedBackgroundType === 'tematikus' && label === 'fotos_borito')
     ||
     (context === 'consumer')
     ? loadConsumerCoverTemplates
     : loadProCoverTemplates
  
    const coverType = getLayoutsByBGAndContext;
    const coverTemplates = coverType[format][type];
    const selectedCover = coverTemplates.sizes.filter(element => element.label === label && !element.only_autofill_layout);
    if(selectedCover[1]){
      dispatch(addLayout(selectedCover[1]));
    }
  }
  


// Load new cover image (Reconfigured book with autofill)
function addNewCoverImage(galleryURI, store, coverPage) {
  fetch(galleryURI)
    .then(response => response.json())
    .then((galleryData) => {
      if ('error' in galleryData) {
        throw galleryData.error;
      }

      const newImages = [galleryData.items[0]];
      loadDefaultImages(newImages, store);
    })
    .then(() => {
      const { images } = store.getState().entities;
      const newCoverImageId = images.allIds.slice(-1)[0];
      store.dispatch(addDroppedImageToPage(coverPage.id, newCoverImageId));
    });
}


// Load refconfigured book
function loadReconfiguredBook(json, coverSize, dispatch, lang, galleryURI, store, images, newImages) {
  dispatch(convertFinished(false));
  loadBookPartials(json, dispatch, coverSize, true);
  const { byId } = json.entities.pages;
  const coverPage = Object.values(byId).find(element => element.isCover);
  
  const { autofill } = json.bookProperties;
  if (!autofill) {
    showAlertModal(lang.title_notice, lang.cover_reedit);
    removeCoverPicture(dispatch, coverPage);
    removeOldCoverLayout(dispatch, json);
    addNewCoverLayout(dispatch, json);
    removeTextsFromCover(dispatch, coverPage);
    dispatch(imageChange(true));
  } else {
    dispatch(deletePages(10));
    dispatch(resetPageToViewed());
    dispatch(addPageToViewed(10));
    dispatch(deleteImages(coverPage.droppedImages));
    removeCoverPicture(dispatch, coverPage);
    if (json.bookProperties.cover.type !== 'calligrafia') {
      addNewCoverImage(galleryURI, store, coverPage);
    }
    // load new images
    const editorImages = getEditorImages({ items: newImages }, false, store);
    dispatch(loadImages(editorImages));
    showAlertModal(lang.title_notice, lang.check_reconfigures_autofill_book);
    dispatch(autoFill(images, true, newImages, true));
    dispatch(convertFinished(true));
  }
  const { byId: layouts } = json.entities.layouts;
  
  const setLayout = Object.values(layouts).find(element => element.isCover);
  setTimeout(() => {
    setCoverToActive(dispatch, coverPage);
    dispatch(setLayoutToActivePage(setLayout.id, coverPage.id));
  }, 0);
}


// Convert old book to new size
function convertBook(editorJson, configuredBookData, dispatch, lang, galleryURI, store, images, newImages) {
  const postBody = {
    json: editorJson,
    book: configuredBookData,
  };
  axios
    .post(
      coverterUrl,
      postBody,
    ).then((response) => {
      const { json } = response.data;
      const coverSize = getSelectedCover(configuredBookData);
      loadReconfiguredBook(json, coverSize, dispatch, lang, galleryURI, store, images, newImages);
    });
}

// Load gallery, and add new images
function loadNewImages(galleryURI, entities, store) {
  fetch(galleryURI)
    .then(response => response.json())
    .then((galleryData) => {
      if ('error' in galleryData) {
        throw galleryData.error;
      }

      const newImages = galleryData.items.filter(galleryElement => Object.values(entities.images.byId).filter(stateImage => stateImage.imageId === galleryElement.id).length === 0);
      loadDefaultImages(newImages, store);
    });
}

export function loadBook(galleryURI, coverSize, label, response, store, lang) {
  return dispatch => axios
    .get(url, {
      withCredentials: true,
      mode: 'no-cors',
    })
    .then(async (repos) => {
      const { type } = store.getState().bookProperties.cover;
      const { type: newType, label: newlabel } = repos.data.json.bookProperties.cover;

      let savedData = repos.data.json;
      const firstGalleryImage = Object.values(repos.data.json.entities.images.byId).find(Boolean).url;
      if (firstGalleryImage.indexOf('http://') === 0) {
        const updateSavedProtocol = await updateProtocol();
        savedData = updateSavedProtocol.success;
      }
      if (savedData) {
        loadBookPartials(savedData, dispatch, coverSize);
        loadNewImages(galleryURI, repos.data.json.entities, store);
      }
      // Convert book to new size
      fetch(galleryURI)
        .then(response => response.json())
        .then((galleryData) => {
          if ('error' in galleryData) {
            throw galleryData.error;
          }

          const oldImageIDs = [];
          const newImageIDs = [];

          Object.values(repos.data.json.entities.images.byId).forEach((element) => {
            oldImageIDs.push(element.imageId);
          });

          Object.values(galleryData.items).forEach((element) => {
            newImageIDs.push(element.id);
          });

          const isConvertedBook = type !== newType || newlabel !== label;
          const images = Object.values(galleryData.items).length;

          if ((difference(oldImageIDs, newImageIDs).length > 0) || isConvertedBook) {
            convertBook(repos.data.json, response, dispatch, lang, galleryURI, store, images, Object.values(galleryData.items));
          }
        });
    })
    .catch((err) => {
      throw err;
    });
}


export async function updateProtocol() {
  const updateUrl = await fetch(`${getStateUrl}/id/${getBookId()}/updateProtocolInEditorJsonForBooks`, {
    cors: 'no-cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const updatedData = await updateUrl.json();
  return updatedData;
}




// WEBPACK FOOTER //
// ./src/redux/helpers/loadBook.js